
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'TabItem',
})
export default class TabItem extends Vue {
  @Prop({ type: String }) value!: string;
}
